import React, { useRef, useState } from "react";
import { toast } from "sonner";
import { UploadCloud, X, Film, Loader2 } from "lucide-react";
import { api, apiErr } from "../../lib/api";
import { mediaUrl } from "../../lib/format";

// value = storage path or url. onChange(path)
export default function Uploader({ value, onChange, onUploaded, accept = "image/*", label = "Imagem", kind = "image", tid = "uploader" }) {
  const inputRef = useRef(null);
  const [progress, setProgress] = useState(null);
  const url = mediaUrl(value);
  const isVideo = kind === "video";

  const pick = () => inputRef.current?.click();

  const handle = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const form = new FormData();
    form.append("file", file);
    setProgress(0);
    try {
      const { data } = await api.post("/upload", form, {
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: (p) => setProgress(Math.round((p.loaded / (p.total || 1)) * 100)),
      });
      onChange(data.path);
      onUploaded?.(data);
      toast.success("Upload concluído");
    } catch (err) {
      toast.error(apiErr(err));
    } finally {
      setProgress(null);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  return (
    <div>
      {label && <label className="text-xs font-semibold text-zinc-400">{label}</label>}
      <input ref={inputRef} type="file" accept={accept} onChange={handle} className="hidden" data-testid={`${tid}-input`} />
      <div className="mt-1.5 relative rounded-xl border border-dashed border-white/15 bg-white/[0.03] overflow-hidden">
        {url ? (
          <div className="relative">
            {isVideo
              ? <video src={url} className="w-full h-40 object-cover" muted playsInline />
              : <img src={url} alt="" className="w-full h-40 object-cover" />}
            <div className="absolute inset-0 bg-black/30 opacity-0 hover:opacity-100 transition-opacity flex items-center justify-center gap-2">
              <button onClick={pick} data-testid={`${tid}-replace`} className="text-xs font-bold bg-white/20 backdrop-blur px-3 py-1.5 rounded-full">Trocar</button>
              <button onClick={() => onChange(null)} data-testid={`${tid}-remove`} className="text-xs font-bold bg-rose-600 px-3 py-1.5 rounded-full flex items-center gap-1"><X size={13} /> Remover</button>
            </div>
          </div>
        ) : (
          <button onClick={pick} data-testid={`${tid}-btn`} className="w-full h-32 flex flex-col items-center justify-center gap-2 text-zinc-500">
            {isVideo ? <Film size={24} /> : <UploadCloud size={24} />}
            <span className="text-xs">Enviar {isVideo ? "vídeo" : "imagem"} do dispositivo</span>
          </button>
        )}
        {progress !== null && (
          <div className="absolute inset-0 bg-black/70 flex flex-col items-center justify-center gap-2">
            <Loader2 className="animate-spin text-[#FF6B00]" />
            <div className="w-2/3 h-1.5 rounded-full bg-white/10 overflow-hidden"><div className="h-full bg-[#FF6B00]" style={{ width: `${progress}%` }} /></div>
            <span className="text-xs text-zinc-300">{progress}%</span>
          </div>
        )}
      </div>
    </div>
  );
}
